<template>
  <div class="sortable-item sortable-item-audio width-fit-content">
    <span class="sortable-item-info">
      <span class="sortable-item-type">
        Audio <span class="sortable-item-type-position">( {{ index + 1 }} )</span>
      </span>
      <span class="sortable-item-action sortable-item-move">
        <i class="far fa-arrows-alt"></i>
      </span>
      <a
        class="sortable-item-action sortable-item-delete"
        href="#"
        @click.prevent="deleteBlock"
      >
        <i class="far fa-trash-alt"></i>
      </a>
    </span>
    <div class="sortable-item-tag">
      <a
        :href="canEdit ? block.data.url : '#'"
        class="file-document-access"
        target="_blank"
      >
        <span class="file-document-access-icon">
          <i class="far fa-file-audio text-color-content-audio"></i>
        </span>
        <span class="file-document-access-info">
          <span class="file-document-access-info-name">
            {{ block.data.url }}
          </span>
          <span class="file-document-access-info-action">
            <i class="far fa-play"></i>
          </span>
        </span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeContentEditorBlockAudio',

  props: {
    block: Object,
    canEdit: {
      type: Boolean,
      default: true
    },
    index: Number,
    time: {
      type: Number,
      default: null
    }
  },

  methods: {
    deleteBlock () {
      if (this.canEdit) {
        this.$emit('deleteBlock', this.index)
      }
    }
  }
}
</script>
